<template>
  <div class="main-page main-layout-field col-block width-full" :class="[windowType]">
    <div class="main-layout-container col-block" :style="{ height: (windowHeight - headerHeight) + 'px' }">
      <div class="main-layout-block col-block">
        <div class="main-layout-main-container" :class="['mobile'].includes(windowType) ? ['col-block', 'width-full'] : ['row-block', 'stretch']" :style="['mobile'].includes(windowType) ? {} : { flex: 1 }">
          <div class="main-announcement-container col-block width-full" :style="['mobile'].includes(windowType) ? {} : { width: '226px' }">
            <div class="main-announcement-header col-block" v-html="['mobile'].includes(windowType) ? ['Compass 衛⽣検査所', '<span>登録番号 | <a class=\'link main\' href=/pdf/第7新保衛医第270号.pdf?v=' + date + '>第7新保衛医第270号</a></span>'].join('<br>')/* ___ */ : ''"></div>
            <div class="main-announcement-block col-block width-full">
              <div class="main-announcement-table-container col-block width-full" :style="['mobile'].includes(windowType) ? {} : { 'max-height': windowHeight - 413.5 + 'px' }">
                <div class="main-announcement-table-block center-block">
                  <div class="main-announcement-table-title">{{ '最新ニュース'/* ___ */ }}</div>
                </div>
                <div class="main-announcement-table-block col-block width-full shrink">
                  <div class="main-announcement-table-content-container col-block width-full">
                    <div class="main-announcement-table-content-block" :class="['mobile'].includes(windowType) ? ['content-block'] : ['col-block', 'flex-start']" v-for="(info, iindex) in announcementInfos['news']" :key="iindex">
                      <div class="main-announcement-table-content-title">{{ info.title }}</div>
                      <div class="main-announcement-table-content-separator"> | </div>
                      <div class="main-announcement-table-content-content" v-html="info.content"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="main-announcement-table-container col-block width-full">
                <div class="main-announcement-table-block center-block empty">
                  <!-- <div class="main-announcement-table-title">{{ 'カレンダー'/* ___ */ }}</div> -->
                </div>
                <div class="main-announcement-table-block col-block width-full">
                  <div class="main-announcement-table-content-container col-block width-full">
                    <div class="main-announcement-table-content-block col-block flex-start" v-for="(info, iindex) in announcementInfos['calendar']" :key="iindex">
                      <div class="main-announcement-table-content-title">{{ info.title }}</div>
                      <component
                        :is="(info.link || info.func) ? 'a' : 'div'"
                        class="main-announcement-table-content-content link main"
                        :href="info.link"
                        target="_blank"
                        @click="e => (info.func || (() => {}))(info)"
                      >{{ info.content }}</component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :style="{ flex: 1 }"></div>
            <div class="main-announcement-footer"></div>
          </div>
          <div class="main-container col-block width-full" :style="{ flex: 1 }">
            <div class="main-title-container col-block width-full">
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
              <div class="main-title-info-container col-block" :class="[['mobile'].includes(windowType) ? '' : 'flex-end']">
                <div class="main-title-info-block" :class="[['mobile'].includes(windowType) ? 'col-block' : 'col-block flex-end']">
                  <template v-for="(file, findex) in topFileInfos" :key="findex">
                    <div class="main-title-info">
                      <span>{{ file.title }}</span>
                      (<span><a class="link main" @click="e => downloadPDFFile(file.url, file.name)">{{ file.display }}</a></span>)
                    </div>
                    <!-- <span v-if="!['mobile'].includes(windowType)" class="split"> | </span> -->
                  </template>
                </div>
              </div>
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
              <mainTable
                :key="windowType"
                :layout="'head'"
                @download="(link, name) => downloadPDFFile(link, name)"
              ></mainTable>
            </div>
            <div class="main-content-container col-block width-full" :style="{ flex: 1 }">
              <mainTable
                :key="windowType"
                :layout="'body'"
                @download="(link, name) => downloadPDFFile(link, name)"
              ></mainTable>
            </div>
            <div class="main-footer-container col-block width-full">
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
              <div class="main-footer" v-html="footerInfo"></div>
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
            </div>
          </div>
        </div>
        <div v-if="['mobile'].includes(windowType)" :style="{ flex: 1 }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mainTable from '@/components/main/table.vue'
import responsitiveData from '@/mixins/responsitiveData.vue'
import { dateFormat, downloadFile, generateHtmlElement } from '@/constants/global/util'

export default {
  components: {
    mainTable
  },
  mixins: [
    responsitiveData
  ],
  data () {
    return {
      date: dateFormat(new Date(), 'yyyyMMddhhmmss')
    }
  },
  computed: {
    // static
    topFileInfos () {
      return [
        {
          title: '検体提出方法および検体基準書'/* ___ */,
          url: '/pdf/検体提出方法および検体基準書.pdf',
          file: '検体提出方法および検体基準書.pdf',
          display: 'PDF'/* ___ */
        },
        {
          title: '検査受付・実施・報告フロー'/* ___ */,
          url: '/pdf/検査受付・実施・報告フロー.pdf',
          file: '検査受付・実施・報告フロー.pdf',
          display: 'PDF'/* ___ */
        },
        {
          title: '新規自費検査項目の開発について'/* ___ */,
          url: '/pdf/新規自費検査項目の開発について.pdf',
          file: '新規自費検査項目の開発について.pdf',
          display: 'PDF'/* ___ */
        }
      ]
    },
    announcementInfos () {
      return {
        'news': [
          {
            title: '2026/10/20',
            content: '新規自費遺伝学的検査項目の開発サービスを開始いたしました。検査項目の設計・開発に追加費用はかかりません。詳しくは「新規自費検査項目の開発について」をご覧ください。'
          },
          {
            title: '2026/10/16',
            content: '11月20日に日本人類遺伝学会第71回大会において、共催セミナーを開催いたします。<<a class="link main" href=/pdf/news/日本人類遺伝第71回大会チラシ.pdf?v=' + this.date + ' target=_blank>詳細情報</a>>'
          },
          {
            title: '2026/10/8',
            content: 'Nanodigm Compass RareSelectPrime V1 + NEXome HmtDNA panel V1.1用の検査案内書、対象遺伝子リスト、および報告書サンプルを追加いたしました。'
          },
          {
            title: '2026/10/5',
            content: 'Roche KAPA HyperExome V2 kit with HyperChoice kit (mtDNA)用の検査案内書、対象遺伝子リスト、および報告書サンプルを改訂いたしました。'
          },
          {
            title: '2026/8/10',
            content: '検査案内書、および検体提出方法および検体基準書を改訂いたしました。'
          },
          {
            title: '2026/7/10',
            content: '先天性溶血性貧血検査（自費）を追加いたしました。'
          },
          {
            title: '2026/7/10',
            content: '検査案内書、対象遺伝子リスト、報告書サンプル、および検体提出方法および検体基準書を改訂いたしました。'
          },
          {
            title: '2026/6/15',
            content: '2026年7月～9月の検査受託スケジュールを更新いたしました。'
          },
          {
            title: '2026/6/9',
            content: '検査案内書および、検体提出方法および検体基準書を改訂いたしました。'
          },
          // {
          //   title: '2026/5/25',
          //   content: '<a href=https://www.cggs.jp/ target=_blank>Compass Global genomic service</a> の外部リンクを追加'
          // },
          {
            title: '2026/3/25',
            content: '「自由診療」との項目名を「保険適用外の遺伝学的検査（自費）」へと変更いたしました。'
          },
          {
            title: '2026/3/25',
            content: '2026年度上半期（4月－9月）の検査受託スケジュールを公開いたしました。'
          },
          {
            title: '2026/3/25',
            content: '<b>2026年6月の診療報酬改定適用開始に伴う、新しい検査項目を追加いたしました。</b>'
          }
        ],
        'calendar': [
          {
            title: '遺伝学的検査の実施に関する指針の遵守について',
            content: '当衛生検査所は、平成28年4月1日に日本小児科学会、日本神経学会、日本人類遺伝学会及び日本衛生検査所協会が共同で策定した「遺伝学的検査の実施に関する指針」を遵守し、遺伝学的検査を実施しています。'
            // func: () => {
            //   this.downloadPDFFile('/pdf/news/2026年度7-9月検体受付・ 報告日程.pdf', '2026年度7-9月検体受付・ 報告日程.pdf')
            // }
          }
        ]
      }
    },
    footerInfo () {
      let footerData = [
        {
          content: ['〒162-0056 東京都新宿区若松町2-2', 'TWIns3階N102'].join(['mobile'].includes(this.windowType) ? ' ' : ' ')/* ___ */
        },
        {
          content: '03-4446-3661',
          link: 'tel:+8144463661'
        }
        // {
        //   content: 'Compass Global genomic service'/* ___ */,
        //   link: 'https://cggs.jp/'
        // }
      ]
      return footerData.map(data => {
        return [
          data.title ? generateHtmlElement('b', data.title) : null,
          generateHtmlElement(data.link ? 'a' : 'span', data.content, data.link ? { href: data.link, class: 'link main' } : '')
        ].filter(x => x).join('  ')
      }).join(['mobile'].includes(this.windowType) ? '\n' : ' | ')
    }
  },
  methods: {
    downloadPDFFile (link, name) {
      link = link + '?v=' + dateFormat(new Date(), 'yyyyMMddhhmmss')
      // this.checkLink(link)
      if (name) {
        // downloadFile(name, link)
        window.open(link)
      } else {
        window.open(link)
      }
    },
    async checkLink (url) {
      // document.querySelectorAll('.pdf-block a.pdf-link.link.main').forEach(el => el.click())
      // document.querySelectorAll('.info-detail-block .link-block a.link.main').forEach(el => el.click())
      try {
        await fetch(url, { method: 'HEAD' })
      } catch (error) {
        console.error(url)
      }
    }
  }
}
</script>
